import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useParcelSubscribePossession = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.IParcelSubscribePossessionRequestData) => {
        const response = await send<Types.IParcelSubscribePossessionRequestData, Types.IParcelSubscribePossessionResponseData>({
            ID: 73030,
            responses: [73032, 73033],
            description: 'Mystery Parcel possession info subscription',
            ...options
        });

        return response;
    }, [send]);
};
